import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class LanguageApiService {
  
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
    private http: HttpClient
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllLanguages(body: any) {
    const link = this.apiUrl + ApiUrls.getLangList;
    return this.http.post<any>(link, body);
  }
}
